
@if (lineHeight() > 0) {
  <div
    [class]="'transport-list-card__transfer' + ' ' + status()"
    [style.--transport-line-height.px]="lineHeight()" 
    [attr.data-is-first]="isFirst()"
    [attr.data-is-last]="isLast()"
  >
    <div class="transfer__line-content-wrapper">
      @if(iconName()) {
        <span 
          [class]="'transport-list-card__line' + ' ' + iconName()"
        ></span>
      }
    </div>
  </div>
}